







































































































































































































































































































































































































































































































































































































































































































































































































































































































import { EventTypes } from '@/constants/event-type-constants';
import {
    differenceInDaysLocal,
    formatDateWithTimezone,
    formatIsoDateTime, getTimeZoneString,
    isoFormatLong
} from '@/date-time/date-time-utils';
import { ChangeStatus } from '@/families/change-status';
import StatusChangeSelect from '@/families/components/StatusChangeSelect.vue';
import BaseDateInput from '@/components/base/BaseDateInput.vue';
import { Family } from '@/families/models/family';
import { FamiliesRepository } from '@/families/repositories/families-repository';
import { PermissionName } from '@/staff/models/user-permission-models';
import { StaffUtils } from '@/staff/staff-utils';
import store from '@/store';
import { AuthStore } from '@/store/auth-store';
import { LoadingStore } from '@/store/loading-store';
import DurationSelect from '@/tasks/components/DurationSelect.vue';
import GuardiansCard from '@/tasks/components/GuardiansCard.vue';
import TaskDescription from '@/tasks/components/TaskDescription.vue';
import TaskDueDateTime from '@/tasks/components/TaskDueDateTime.vue';
import TaskDueBar from '@/tasks/components/TaskDueBar.vue';
import TaskResultSelect from '@/tasks/components/TaskResultSelect.vue';
import TaskTypeSelect from '@/tasks/components/TaskTypeSelect.vue';
import { TaskMapper } from '@/tasks/mappers/task-mapper';
import { Task, TaskType, TaskUpdateDto } from '@/tasks/models/task-models';
import { LocaleMixin } from '@/locales/locale-mixin';
import { TasksRepository } from '@/tasks/repositories/tasks-repository';
import { isTaskPastDue, TaskUtilities } from '@/tasks/task-utils';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import CenterAscendingStaffList from '@/staff/components/CenterAscendingStaffList.vue';
import { getModule } from 'vuex-module-decorators';
import { CentersStore } from '@/organizations/locations/stores/centers-store';
import AddTaskModal from '@/tasks/components/AddTaskModal.vue';
import { AppStateStore } from '@/store/app-state-store';
import SendReminderInputs from '@/tasks/components/SendReminderInputs.vue';
import { isDoNotEmail, isDoNotText, getChildAge } from '@/families/families-utils';
import { ChildUpdateDtoInterface } from '@/families/models/child';
import { ChildrenRepository } from '@/families/repositories/children-repository';
import { ChildMapper } from '@/families/mappers/child-mapper';
import { cloneDeep } from 'lodash';
import { StatusChangesStore } from '@/families/store/status-changes-store';
import { enrollmentTeamPlaceholder } from '@/enrollment-center/models/enrollment-center-models';
import { TasksStore } from '@/tasks/stores/tasks-store';
import { FeaturesStore } from '@/features/features-store';
import { FeatureConstants } from '@/features/feature-constants';
import { downloadIcsFile } from '@/calendar/calendar-utils';
import { SixAgentStore } from '@/integrations/store/six-agent-store';
import { SixAgentUtils } from '@/integrations/six-agent-utils';
import BaseClose from '@/components/base/BaseClose.vue';
import TaskConfirmationModal from '@/components/base/TaskConfirmationModal.vue';
import { LayoutTabsStore } from '@/store/layout-tabs-store';
import { ClientInfoStore } from '@/organizations/corporate/stores/client-info-store';
import { TaskDefaultsStore } from '@/tasks/stores/task-defaults-store';

const appState = getModule(AppStateStore);
const authStore = getModule(AuthStore, store);
const changeStatus = new ChangeStatus();
const changeStatusStore = getModule(StatusChangesStore);
const childMapper = new ChildMapper();
const childrenRepo = new ChildrenRepository();
const familiesRepository = new FamiliesRepository();
const loadingState = getModule(LoadingStore);
const staffUtils = new StaffUtils();
const featureState = getModule(FeaturesStore);
const taskMapper = new TaskMapper();
const tasksRepository = new TasksRepository();
const taskUtils = new TaskUtilities();
const centersStore = getModule(CentersStore);
const tasksStore = getModule(TasksStore);
const featuresStore = getModule(FeaturesStore);
const sixAgentState = getModule(SixAgentStore);
const sixAgentUtils = new SixAgentUtils();
const layoutTabsStore = getModule(LayoutTabsStore, store);
const clientInfoStore = getModule(ClientInfoStore);
const taskDefaultsStore = getModule(TaskDefaultsStore);

@Component({
    components: {
        BaseClose,
        BaseDateInput,
        TaskConfirmationModal,
        SendReminderInputs,
        GuardiansCard,
        DurationSelect,
        TaskTypeSelect,
        TaskDueDateTime,
        TaskDueBar,
        TaskResultSelect,
        TaskDescription,
        StatusChangeSelect,
        CenterAscendingStaffList,
        AddTaskModal
    }
})
export default class ManageTaskModal extends Mixins(LocaleMixin) {
    @Prop() task!: Task | null;
    @Prop() isMeeting!: boolean;
    @Prop({ default: false }) completedEdit!: boolean;
    @Prop({ default: false }) readonly etDashMode!: boolean;

    private taskDto: TaskUpdateDto | null = null;
    private family: Family | null = null;
    private assignedToStaffId!: number;
    private taskSaved = false;
    private taskSavedMessage = `${this.isMeeting ? 'Meeting' : 'Task'} ${this.isNewTaskModal ? 'Saved' : 'Updated'}`;
    private resultDescription = '';
    private saveButtonText = 'Save';
    private isLoaded = false;
    private isOpen = true;
    private isComplete = false;
    private isChanged = false;
    private isDueDateChange = false;
    private isTaskTypeChange = false;
    private isDescriptionChange = false;
    private isValid = true;
    private isSaving = false;
    private isValidDueDate = true;
    private loadingKey = 'manageTaskLoading';
    // Task type name before changes
    private taskTypeName = this.task?.type.values.value;
    // Event for viewing a family
    private viewFamilyEvent = EventTypes.FAMILY_VIEW;
    private tzDue = '';
    private newTzDue: Date | null = null;
    private addTaskModal = false;
    private currentTab = '';
    private isResultChanged = false;
    private canEdit = false;
    private canEmail = true; // Is "email" reminder allowed?
    private canText = true; // Is "text" reminder allowed?
    private exportToIcsFile = false;
    private sendTextReminderGuardian = true;
    private sendEmailReminderGuardian = true;
    private sendTextReminderStaff = true;
    private sendEmailReminderStaff = true;
    private guardianTextReminderAmount: string | null = null;
    private guardianTextReminderUnit: string | null | undefined = null;
    private guardianEmailReminderAmount: string | null = null;
    private guardianEmailReminderUnit: string | null | undefined = null;
    private staffTextReminderAmount: string | null = null;
    private staffTextReminderUnit: string | null | undefined = null;
    private staffEmailReminderAmount: string | null = null;
    private staffEmailReminderUnit: string | null | undefined = null;
    private isGuardianTextReminderValid = true;
    private isGuardianEmailReminderValid = true;
    private isStaffTextReminderValid = true;
    private isStaffEmailReminderValid = true;
    private etPlaceholder = enrollmentTeamPlaceholder;
    private initialPastDue = false;
    // we have to keep track of tz edit separately so it can be changed
    // independently of time
    private chosenTimezone = '';
    private description = '';
    private statusChangeExpansionPanels: number[] = [];
    private showWarningDrawer = false;
    private showDeleteSnackbar = false;
    private showSaveSnackbar = false;
    private deleteSnackbarMessage = '';
    private saveSnackbarMessage = '';
    private createAnotherText = '';
    private createNewText = '';
    private loadVersion = 0;
    // DTOs for editing child data, separate from the original child objects to prevent
    // triggering StatusChangeSelect's deep watcher
    private childDtos: Array<ChildUpdateDtoInterface> = [];
    private originalChildDtos: Array<ChildUpdateDtoInterface> = [];

    get center() {
        return appState.storedCurrentCenter;
    }

    get hasTextMessagingService() {
        return clientInfoStore.hasTextMessagingService;
    }

    get isCancelled(): boolean {
       if (this.task) {
           return this.task.is_cancelled;
       }
        return false;
    }

    get isOnFamilyHubPage(): boolean {
        return this.$route.name === 'family-hub';
    }

    getChildAge(child: any): string {
        return getChildAge(child);
    }

    getChildName(child: any): string {
        return child.name || `${child.first_name} ${child.last_name}`;
    }

    isChildNameTruncated(child: any): boolean {
        const childName = this.getChildName(child);
        return childName.length > 20;
    }

    get taskLabel() {
        return this.isMeeting ? 'meeting' : 'task';
    }

    get showTimezones() {
        return featuresStore.isFeatureEnabled(FeatureConstants.CRM_PLUS_MODE);
    }

    get dueTimeString() {
        if (this.taskDto) {
            return this.formatTime(this.taskDto.due_date_time, this.timezone) + (this.showTimezones ? ' ' + this.timezoneString : '');
        }
        return '';
    }

    get timezoneString() {
        if (this.taskDto && this.chosenTimezone) {
            return getTimeZoneString(new Date(this.taskDto.due_date_time), this.chosenTimezone, this.$i18n.locale);
        }
        return '';
    }

    get sixAgentContactCount() {
        return sixAgentState.contactCount;
    }

    get canAddCrmTabs(): boolean {
        return featuresStore.isFeatureEnabled(FeatureConstants.INCONTACT) && authStore.isEnrollmentTeamMember;
    }

    get isNewTaskModal() {
        return featureState.isNewTaskModal;
    }

    get newTabStatus() {
        return this.etDashMode && appState.familyHubTargetMode;
    }

    get timezone() {
        return authStore.userTimeZone;
    }

    get areRemindersValid(): boolean {
        // Only validate reminders for new task modal
        if (this.isNewTaskModal) {
            const guardianTextValid = !this.sendTextReminderGuardian || this.isGuardianTextReminderValid;
            const guardianEmailValid = !this.sendEmailReminderGuardian || this.isGuardianEmailReminderValid;
            const staffTextValid = !this.sendTextReminderStaff || this.isStaffTextReminderValid;
            const staffEmailValid = !this.sendEmailReminderStaff || this.isStaffEmailReminderValid;
            return guardianTextValid && guardianEmailValid && staffTextValid && staffEmailValid;
        }
        return true;
    }

    async getTzDue() {
        if (!this.taskDto) {
            return '';
        }

        return formatDateWithTimezone(this.taskDto.due_date_time, this.timezone, isoFormatLong);
    }

    @Watch('sixAgentContactCount')
    sixAgentCountChanged(newCount: number, oldCount: number) {
        if (newCount > oldCount && sixAgentState.loggedIn && this.family) {
            sixAgentUtils.addPossibleContact(this.family);
        }
    }

    @Watch('resultDescription')
    private updateResultDescription() {
        if (!this.taskDto || !this.isLoaded) {
            return;
        }
        const taskDtoValue = (this.taskDto.result_description || '').trim();
        const currentValue = (this.resultDescription || '').trim();
        this.isChanged = taskDtoValue !== currentValue;
    }

    @Watch('description')
    private updateDescription() {
        if (!this.taskDto || !this.isLoaded) {
            return;
        }
        const taskDtoValue = (this.taskDto.description || '').trim();
        const currentValue = (this.description || '').trim();
        this.isChanged = taskDtoValue !== currentValue;
    }

    @Watch('task', { immediate: true, deep: true })
    async updateData() {
        if (!this.task) {
            // Reset state.
            this.isOpen = false;
            this.isComplete = false;
            this.isChanged = false;
            this.isDueDateChange = false;
            this.isTaskTypeChange = false;
            this.isValid = true;
            this.isResultChanged = false;
            this.isValidDueDate = true;
            this.exportToIcsFile = false;
            this.taskDto = null;
            if (this.family) {
                changeStatusStore.clear(this.family.id);
            }
            this.isLoaded = false;
            this.tzDue = '';

            this.canEdit = false;
            this.canEmail = true;
            this.sendEmailReminderGuardian = this.canEmail;
            this.canText = true;
            this.sendTextReminderGuardian = this.canText;
            return;
        }

        if (this.task) {
            if (this.isNewTaskModal) {
                const currentVersion = ++this.loadVersion;
                this.isOpen = true;
                this.isLoaded = false;
                this.family = null;
                this.taskDto = null;
                this.resultDescription = '';
                this.description = '';
                await this.loadAdditionalData(currentVersion);
            } else {
                loadingState.loadingIncrement(this.loadingKey);
                const responses = await Promise.all([
                    familiesRepository.getOne(this.task.family.id),
                    staffUtils.getUserPermission(PermissionName.TasksEditOthers)
                ]);
                const canEditOthersTasks = responses[1];
                this.chosenTimezone = this.timezone;
                this.family = responses[0];
                this.initializeChildDtos(this.family);
                if (sixAgentState.loggedIn) {
                    sixAgentUtils.addPossibleContact(this.family);
                    }
                this.assignedToStaffId = this.task.assigned_to_staff ? this.task.assigned_to_staff.id : 0;
                if (this.task.assigned_to_enrollment_team === 1 && this.assignedToStaffId === 0) {
                    this.assignedToStaffId = enrollmentTeamPlaceholder;
                }
                this.canEdit = !(this.assignedToStaffId !== authStore.userInfoObject?.id && !canEditOthersTasks);
                this.exportToIcsFile = false;
                this.taskDto = taskMapper.toUpdateDto(this.task);
                this.taskTypeName = this.task.type.values.value;
                this.tzDue = await this.getTzDue();
                this.newTzDue = null;
                this.canEmail = !isDoNotEmail(this.family);
                this.sendEmailReminderGuardian = this.canEmail && this.task.reminder_times.primary_guardian_email_reminder !== null && parseInt(this.task.reminder_times.primary_guardian_email_reminder.split('')[0]) !== 0;
                this.canText = !isDoNotText(this.family);
                this.sendTextReminderGuardian = this.canText && this.task.reminder_times.primary_guardian_text_reminder !== null && parseInt(this.task.reminder_times.primary_guardian_text_reminder.split('')[0]) !== 0;
                this.sendEmailReminderStaff = this.task.reminder_times.staff_email_reminder !== null && parseInt(this.task.reminder_times.staff_email_reminder.split('')[0]) !== 0;
                this.sendTextReminderStaff = this.task.reminder_times.staff_text_reminder !== null && parseInt(this.task.reminder_times.staff_text_reminder.split('')[0]) !== 0;

                if (this.isMeeting) {
                    if (this.sendEmailReminderGuardian) {
                        this.taskDto.primary_guardian_email_reminder_amount = this.task.reminder_times.primary_guardian_email_reminder ? parseInt(this.task.reminder_times.primary_guardian_email_reminder.split(' ')[0]) : null;
                        this.taskDto.primary_guardian_email_reminder_unit = this.task.reminder_times.primary_guardian_email_reminder ? this.task.reminder_times.primary_guardian_email_reminder.split(' ')[1] : null;
                    }
                    if (this.sendTextReminderGuardian) {
                        this.taskDto.primary_guardian_text_reminder_amount = this.task.reminder_times.primary_guardian_text_reminder ? parseInt(this.task.reminder_times.primary_guardian_text_reminder.split(' ')[0]) : null;
                        this.taskDto.primary_guardian_text_reminder_unit = this.task.reminder_times.primary_guardian_text_reminder ? this.task.reminder_times.primary_guardian_text_reminder.split(' ')[1] : null;
                    }
                    this.initialPastDue = isTaskPastDue(this.taskDto);
                }

                if (this.sendEmailReminderStaff) {
                    this.taskDto.staff_email_reminder_amount = this.task.reminder_times.staff_email_reminder ? parseInt(this.task.reminder_times.staff_email_reminder.split(' ')[0]) : null;
                    this.taskDto.staff_email_reminder_unit = this.task.reminder_times.staff_email_reminder ? this.task.reminder_times.staff_email_reminder.split(' ')[1] : null;
                }

                if (this.sendTextReminderStaff) {
                    this.taskDto.staff_text_reminder_amount = this.task.reminder_times.staff_text_reminder ? parseInt(this.task.reminder_times.staff_text_reminder.split(' ')[0]) : null;
                    this.taskDto.staff_text_reminder_unit = this.task.reminder_times.staff_text_reminder ? this.task.reminder_times.staff_text_reminder.split(' ')[1] : null;
                }

                this.guardianTextReminderAmount = this.taskDto.primary_guardian_text_reminder_amount ? this.taskDto.primary_guardian_text_reminder_amount.toString() : null;
                this.guardianTextReminderUnit = this.taskDto.primary_guardian_text_reminder_unit ? this.taskDto.primary_guardian_text_reminder_unit : null;
                this.guardianEmailReminderAmount = this.taskDto.primary_guardian_email_reminder_amount ? this.taskDto.primary_guardian_email_reminder_amount.toString() : null;
                this.guardianEmailReminderUnit = this.taskDto.primary_guardian_email_reminder_unit ? this.taskDto.primary_guardian_email_reminder_unit : null;
                this.staffTextReminderAmount = this.taskDto.staff_text_reminder_amount ? this.taskDto.staff_text_reminder_amount.toString() : '15';
                this.staffTextReminderUnit = this.taskDto.staff_text_reminder_unit ? this.taskDto.staff_text_reminder_unit : 'minute';
                this.staffEmailReminderAmount = this.taskDto.staff_email_reminder_amount ? this.taskDto.staff_email_reminder_amount.toString() : '10';
                this.staffEmailReminderUnit = this.taskDto.staff_email_reminder_unit ? this.taskDto.staff_email_reminder_unit : 'hour';
                this.resultDescription = this.taskDto.result_description ? this.taskDto.result_description : '';
                this.description = this.taskDto.description ? this.taskDto.description : '';
                this.isLoaded = true;
                this.isChanged = false;
                this.isResultChanged = false;
                this.isOpen = true;
                loadingState.loadingDecrement(this.loadingKey);
            }
        }
    }

    private async loadAdditionalData(version: number) {
        loadingState.loadingIncrement(this.loadingKey);
        try {
            const responses = await Promise.all([
                familiesRepository.getOne(this.task!.family.id),
                staffUtils.getUserPermission(PermissionName.TasksEditOthers)
            ]);
            if (version !== this.loadVersion) {
                loadingState.loadingDecrement(this.loadingKey);
                return;
            }
            const canEditOthersTasks = responses[1];
            this.family = responses[0];
            this.initializeChildDtos(this.family);
            if (sixAgentState.loggedIn) {
                sixAgentUtils.addPossibleContact(this.family);
            }
            this.taskDto = taskMapper.toUpdateDto(this.task!);
            this.taskTypeName = this.task!.type.values.value;
            this.assignedToStaffId = this.task!.assigned_to_staff ? this.task!.assigned_to_staff.id : 0;
            if (this.task!.assigned_to_enrollment_team === 1 && this.assignedToStaffId === 0) {
                this.assignedToStaffId = enrollmentTeamPlaceholder;
            }
            this.chosenTimezone = this.timezone;
            this.exportToIcsFile = false;
            this.newTzDue = null;

            this.canEdit = !(this.assignedToStaffId !== authStore.userInfoObject?.id && !canEditOthersTasks);
            this.tzDue = await this.getTzDue();
            if (version !== this.loadVersion) {
                return;
            }
            this.canEmail = !isDoNotEmail(this.family);
            this.sendEmailReminderGuardian = this.canEmail && this.task!.reminder_times.primary_guardian_email_reminder !== null && parseInt(this.task!.reminder_times.primary_guardian_email_reminder.split('')[0]) !== 0;
            this.canText = !isDoNotText(this.family);
            this.sendTextReminderGuardian = this.canText && this.task!.reminder_times.primary_guardian_text_reminder !== null && parseInt(this.task!.reminder_times.primary_guardian_text_reminder.split(' ')[0]) !== 0;
            this.sendEmailReminderStaff = this.task!.reminder_times.staff_email_reminder !== null && parseInt(this.task!.reminder_times.staff_email_reminder.split(' ')[0]) !== 0;
            this.sendTextReminderStaff = this.task!.reminder_times.staff_text_reminder !== null && parseInt(this.task!.reminder_times.staff_text_reminder.split(' ')[0]) !== 0;

            if (this.isMeeting) {
                if (this.sendEmailReminderGuardian) {
                    this.taskDto!.primary_guardian_email_reminder_amount = this.task!.reminder_times.primary_guardian_email_reminder ? parseInt(this.task!.reminder_times.primary_guardian_email_reminder.split(' ')[0]) : null;
                    this.taskDto!.primary_guardian_email_reminder_unit = this.task!.reminder_times.primary_guardian_email_reminder ? this.task!.reminder_times.primary_guardian_email_reminder.split(' ')[1] : null;
                }
                if (this.sendTextReminderGuardian) {
                    this.taskDto!.primary_guardian_text_reminder_amount = this.task!.reminder_times.primary_guardian_text_reminder ? parseInt(this.task!.reminder_times.primary_guardian_text_reminder.split(' ')[0]) : null;
                    this.taskDto!.primary_guardian_text_reminder_unit = this.task!.reminder_times.primary_guardian_text_reminder ? this.task!.reminder_times.primary_guardian_text_reminder.split(' ')[1] : null;
                }
                this.initialPastDue = isTaskPastDue(this.taskDto!);
            }

            if (this.sendEmailReminderStaff) {
                this.taskDto!.staff_email_reminder_amount = this.task!.reminder_times.staff_email_reminder ? parseInt(this.task!.reminder_times.staff_email_reminder.split(' ')[0]) : null;
                this.taskDto!.staff_email_reminder_unit = this.task!.reminder_times.staff_email_reminder ? this.task!.reminder_times.staff_email_reminder.split(' ')[1] : null;
            }

            if (this.sendTextReminderStaff) {
                this.taskDto!.staff_text_reminder_amount = this.task!.reminder_times.staff_text_reminder ? parseInt(this.task!.reminder_times.staff_text_reminder.split(' ')[0]) : null;
                this.taskDto!.staff_text_reminder_unit = this.task!.reminder_times.staff_text_reminder ? this.task!.reminder_times.staff_text_reminder.split(' ')[1] : null;
            }

            this.guardianTextReminderAmount = this.taskDto.primary_guardian_text_reminder_amount ? this.taskDto.primary_guardian_text_reminder_amount.toString() : null;
            this.guardianTextReminderUnit = this.taskDto.primary_guardian_text_reminder_unit ? this.taskDto.primary_guardian_text_reminder_unit : null;
            this.guardianEmailReminderAmount = this.taskDto.primary_guardian_email_reminder_amount ? this.taskDto.primary_guardian_email_reminder_amount.toString() : null;
            this.guardianEmailReminderUnit = this.taskDto.primary_guardian_email_reminder_unit ? this.taskDto.primary_guardian_email_reminder_unit : null;
            this.staffTextReminderAmount = this.taskDto.staff_text_reminder_amount ? this.taskDto.staff_text_reminder_amount.toString() : '15';
            this.staffTextReminderUnit = this.taskDto.staff_text_reminder_unit ? this.taskDto.staff_text_reminder_unit : 'minute';
            this.staffEmailReminderAmount = this.taskDto.staff_email_reminder_amount ? this.taskDto.staff_email_reminder_amount.toString() : '10';
            this.staffEmailReminderUnit = this.taskDto.staff_email_reminder_unit ? this.taskDto.staff_email_reminder_unit : 'hour';
            this.resultDescription = this.taskDto.result_description ? this.taskDto.result_description : '';
            this.description = this.taskDto.description ? this.taskDto.description : '';
            this.isComplete = this.taskDto.result_type !== undefined && this.taskDto.result_type !== null;
            this.isLoaded = true;
            this.isChanged = false;
            this.isResultChanged = false;
            loadingState.loadingDecrement(this.loadingKey);
            this.$nextTick(() => {
                this.isChanged = false;
                this.isResultChanged = false;

                this.setInitialFocus();
                setTimeout(() => {
                    this.isChanged = false;
                    this.isResultChanged = false;
                }, 100);
            });
        } catch (error) {
            if (version === this.loadVersion) {
                loadingState.loadingDecrement(this.loadingKey);
                this.isLoaded = true;
            } else {
                loadingState.loadingDecrement(this.loadingKey);
            }
        }
    }

    @Watch('exportToIcsFile')
    private triggerChange() {
        if (this.exportToIcsFile) {
            this.isChanged = true;
        }
    }

    /**
     * Initialize child DTOs and clone for comparison to prevent triggering StatusChangeSelect's deep watcher
     */
    private initializeChildDtos(family: Family | null) {
        if (family && family.children) {
            this.childDtos = family.children.map(child => childMapper.toUpdateDto(child));
            this.originalChildDtos = cloneDeep(this.childDtos);
        }
    }

    async created() {
        loadingState.loadingIncrement(this.loadingKey);

        // Make sure centers are loaded up.

        const centersResponse = centersStore.initAccessibleCenters();
        const featureResponse = featuresStore.init();
        if (this.isNewTaskModal) {
            Promise.all([centersResponse, featureResponse]);
        } else {
            await centersResponse;
            await featureResponse;
        }

        loadingState.loadingDecrement(this.loadingKey);
    }

    async mounted() {
        if (this.task) {
            await this.updateData();
            if (this.isNewTaskModal) {
                this.$nextTick(() => {
                    this.setInitialFocus();
                });
            }
        }
    }

    private setInitialFocus() {
        if (this.isNewTaskModal) {
            const taskTypeElement = this.$el.querySelector('[data-cy="task-type-select"]');
            if (taskTypeElement) {
                (taskTypeElement as HTMLElement).focus();
            }
        } else {
            if (this.canEdit && !this.isCancelled) {
                const taskTypeElement = this.$el.querySelector('[data-cy="task-type-select-placeholder"]');
                if (taskTypeElement) {
                    (taskTypeElement as HTMLElement).focus();
                }
            } else {
                const descriptionElement = this.$el.querySelector('[data-cy="taskDto-description"]');
                if (descriptionElement) {
                    (descriptionElement as HTMLElement).focus();
                }
            }
        }
    }

    private dueColor() {
        if (!this.taskDto) {
            return;
        }

        if (!this.task) {
            return '';
        }

        const today = new Date();
        if (differenceInDaysLocal(this.taskDto.due_date_time, today.toDateString()) > 0) {
            return 'red--text';
        }
        return '';
    }

    private setTaskType(taskType: TaskType) {
        if (!this.taskDto) {
            return;
        }

        if (this.task && taskType && taskType.id) {
            this.taskDto.type = taskType.id;
            this.taskTypeName = taskType.value;
            this.isTaskTypeChange = false;
            this.isChanged = true;
        }
    }

    private setTaskResult(result: number|undefined) {
        if (!this.taskDto) {
            return;
        }

        this.taskDto.result_type = result;
        this.isComplete = result !== undefined;
        const originalResultId = this.task && this.task.result && this.task.result.id ? this.task.result.id : null;
        const currentResultId = result || null;
        this.isResultChanged = originalResultId !== currentResultId;
        this.updateOverallChangedState();
    }

    private updateOverallChangedState() {
        const resultChanged = this.isResultChanged;
        const descriptionChanged = this.checkDescriptionChanged();
        const resultDescriptionChanged = this.checkResultDescriptionChanged();
        this.isChanged = resultChanged || descriptionChanged || resultDescriptionChanged;
    }

    private checkDescriptionChanged(): boolean {
        if (!this.taskDto) return false;
        const originalDescription = (this.taskDto.description || '').trim();
        const currentDescription = (this.description || '').trim();
        return originalDescription !== currentDescription;
    }

    private checkResultDescriptionChanged(): boolean {
        if (!this.taskDto) return false;
        const originalResultDescription = (this.taskDto.result_description || '').trim();
        const currentResultDescription = (this.resultDescription || '').trim();
        return originalResultDescription !== currentResultDescription;
    }

    private setAssignedTo(assignedToStaffId: number) {
        if (!this.taskDto) {
            return;
        }

        this.taskDto.assigned_to_staff = assignedToStaffId;
        if (assignedToStaffId === enrollmentTeamPlaceholder) {
            this.taskDto.assigned_to_staff = 0;
            this.taskDto.assigned_to_enrollment_team_group = 1;
        } else {
            this.taskDto.assigned_to_enrollment_team_group = 0;
        }
        this.isChanged = true;
    }

    private async watchDueDateChange(dueDateTime: Date|null) {
        if (!this.taskDto) {
            return;
        }

        if (dueDateTime !== null) {
            this.newTzDue = dueDateTime;
            this.taskDto.due_date_time = formatIsoDateTime(dueDateTime, this.timezone);
            this.isValid = true;
            this.isValidDueDate = true;
        } else {
            this.isValid = false;
            this.isValidDueDate = false;
        }
    }

    private saveDueDateChange() {
        if (!this.task) {
            return;
        }

        this.isDueDateChange = false;
        this.isChanged = true;
    }

    private cancelDueDateChange() {
        if (!this.task || !this.taskDto) {
            return;
        }

        this.taskDto.due_date_time = this.task.due_date_time;
        this.chosenTimezone = this.timezone;
        this.isDueDateChange = false;
    }

    private updateDuration(duration: number|undefined) {
        if (!this.taskDto) {
            return;
        }

        this.taskDto.duration = duration;
        this.isChanged = true;
        this.isValid = duration !== undefined;
    }

    private updateAmountInputs() {
        this.isChanged = true;
    }

    private updateUnitInputs() {
        this.isChanged = true;
    }

    private async saveTask() {
        if (!this.taskDto) {
            return;
        }

        this.task = this.task as Task;
        this.isSaving = true;

        loadingState.loadingIncrement(this.loadingKey);
        if (this.resultDescription) {
            this.taskDto.result_description = this.resultDescription;
        }
        if (this.description) {
            this.taskDto.description = this.description;
        }
        if (this.showTimezones && this.newTzDue) {
            this.taskDto.due_date_time = formatIsoDateTime(this.newTzDue, this.chosenTimezone);
        }
        if (this.isMeeting) {
            if (this.sendEmailReminderGuardian || this.task.reminder_times.primary_guardian_email_reminder !== null) {
                let amount = 0;
                let units = 'second';
                if (this.sendEmailReminderGuardian) {
                    amount = this.guardianEmailReminderAmount !== null ? parseInt(this.guardianEmailReminderAmount) : 0;
                    units = this.guardianEmailReminderUnit !== null ? this.guardianEmailReminderUnit as string : '';
                }
                this.taskDto.primary_guardian_email_reminder_amount = amount;
                this.taskDto.primary_guardian_email_reminder_unit = units;
            }
            if (this.sendTextReminderGuardian || this.task.reminder_times.primary_guardian_text_reminder !== null) {
                let amount = 0;
                let units = 'second';
                if (this.sendTextReminderGuardian) {
                    amount = this.guardianTextReminderAmount !== null ? parseInt(this.guardianTextReminderAmount) : 0;
                    units = this.guardianTextReminderUnit !== null ? this.guardianTextReminderUnit as string : '';
                }
                this.taskDto.primary_guardian_text_reminder_amount = amount;
                this.taskDto.primary_guardian_text_reminder_unit = units;
            }
        }
        if (this.sendEmailReminderStaff || this.task.reminder_times.staff_email_reminder !== null) {
            let amount = 0;
            let units = 'second';
            if (this.sendEmailReminderStaff) {
                amount = this.staffEmailReminderAmount !== null ? parseInt(this.staffEmailReminderAmount) : 0;
                units = this.staffEmailReminderUnit !== null ? this.staffEmailReminderUnit as string : '';
            }
            this.taskDto.staff_email_reminder_amount = amount;
            this.taskDto.staff_email_reminder_unit = units;
        }

        if (this.sendTextReminderStaff || this.task.reminder_times.staff_text_reminder !== null) {
            let amount = 0;
            let units = 'second';
            if (this.sendTextReminderStaff) {
                amount = this.staffTextReminderAmount !== null ? parseInt(this.staffTextReminderAmount) : 0;
                units = this.staffTextReminderUnit !== null ? this.staffTextReminderUnit as string : '';
            }
            this.taskDto.staff_text_reminder_amount = amount;
            this.taskDto.staff_text_reminder_unit = units;
        }
        if (this.isComplete && !this.completedEdit) {
            await this.completeTask(this.taskDto);
            if (this.isNewTaskModal) {
                this.saveSnackbarMessage = this.isMeeting ? 'Meeting Saved' : 'Task Saved';
                this.createAnotherText = this.isMeeting ? 'Create Another Meeting' : 'Create Another Task';
                this.createNewText = this.isMeeting ? 'Create a New Task' : 'Create a New Meeting';
                this.showSaveSnackbar = true;
                setTimeout(() => {
                    this.showSaveSnackbar = false;
                }, 12000);
            }
        } else {
            if (this.isMeeting) {
                if (this.initialPastDue) {
                    if (!isTaskPastDue(this.taskDto)) {
                        tasksStore.decrementPastDueToursWithin30DaysCount();
                    }
                } else {
                    if (isTaskPastDue(this.taskDto)) {
                        tasksStore.incrementPastDueToursWithin30DaysCount();
                    }
                }
            }
            const updatedTask = await tasksRepository.update(this.taskDto);
            if (this.isNewTaskModal) {
                this.updateDefaultsInStore();
            }
            if (this.isMeeting && this.exportToIcsFile) {
                downloadIcsFile(updatedTask);
            }
            if (this.family) {
                // Save child birth date changes if modified (only in new task modal)
                if (this.isNewTaskModal && this.childDtos.length > 0) {
                    for (let i = 0; i < this.childDtos.length; i++) {
                        if (this.childDtos[i].date_of_birth !== this.originalChildDtos[i].date_of_birth) {
                            await childrenRepo.update(this.family.id, this.childDtos[i]);
                        }
                    }
                }
                await changeStatus.writePendingChanges(this.family.id);
            }
        }

        loadingState.loadingDecrement(this.loadingKey);
        this.isSaving = false;
        this.closeModal(true);
    }

    private updateDefaultsInStore() {
        if (this.isMeeting) {
            const meetingDefaults = {
                guardianEmailEnabled: this.canEmail ? this.sendEmailReminderGuardian : false,
                guardianEmailAmount: this.canEmail && this.sendEmailReminderGuardian && this.guardianEmailReminderAmount !== null ? parseInt(this.guardianEmailReminderAmount) : null,
                guardianEmailUnit: this.canEmail && this.sendEmailReminderGuardian ? (this.guardianEmailReminderUnit as any) : null,
                guardianTextEnabled: this.canText ? this.sendTextReminderGuardian : false,
                guardianTextAmount: this.canText && this.sendTextReminderGuardian && this.guardianTextReminderAmount !== null ? parseInt(this.guardianTextReminderAmount) : null,
                guardianTextUnit: this.canText && this.sendTextReminderGuardian ? (this.guardianTextReminderUnit as any) : null,
                staffEmailEnabled: this.sendEmailReminderStaff,
                staffEmailAmount: this.sendEmailReminderStaff && this.staffEmailReminderAmount !== null ? parseInt(this.staffEmailReminderAmount) : null,
                staffEmailUnit: this.sendEmailReminderStaff ? (this.staffEmailReminderUnit as any) : null,
                staffTextEnabled: this.sendTextReminderStaff,
                staffTextAmount: this.sendTextReminderStaff && this.staffTextReminderAmount !== null ? parseInt(this.staffTextReminderAmount) : null,
                staffTextUnit: this.sendTextReminderStaff ? (this.staffTextReminderUnit as any) : null,
                addToCalendar: this.exportToIcsFile
            } as any;
            taskDefaultsStore.setMeetingDefaults(meetingDefaults);
        } else {
            const taskDefaults = {
                staffEmailEnabled: this.sendEmailReminderStaff,
                staffEmailAmount: this.sendEmailReminderStaff && this.staffEmailReminderAmount !== null ? parseInt(this.staffEmailReminderAmount) : null,
                staffEmailUnit: this.sendEmailReminderStaff ? (this.staffEmailReminderUnit as any) : null,
                staffTextEnabled: this.sendTextReminderStaff,
                staffTextAmount: this.sendTextReminderStaff && this.staffTextReminderAmount !== null ? parseInt(this.staffTextReminderAmount) : null,
                staffTextUnit: this.sendTextReminderStaff ? (this.staffTextReminderUnit as any) : null
            } as any;
            taskDefaultsStore.setTaskDefaults(taskDefaults);
        }
    }

    private async saveTaskAndShowSnackbar() {
        if (this.isMeeting) {
            this.saveSnackbarMessage = 'Meeting Saved';
            this.createAnotherText = 'Create Another Meeting';
            this.createNewText = 'Create a New Task';
        } else {
            this.saveSnackbarMessage = 'Task Saved';
            this.createAnotherText = 'Create Another Task';
            this.createNewText = 'Create a New Meeting';
        }
        this.showSaveSnackbar = true;

        await this.saveTask();
        setTimeout(() => {
            this.showSaveSnackbar = false;
        }, 12000);
    }

    // Save and pop up task modal
    private async saveAddTask() {
        await this.saveTask();
        if (this.isNewTaskModal) {
            if (this.isMeeting) {
                this.saveSnackbarMessage = 'Meeting Saved';
                this.createAnotherText = 'Create Another Meeting';
                this.createNewText = 'Create a New Task';
            } else {
                this.saveSnackbarMessage = 'Task Saved';
                this.createAnotherText = 'Create Another Task';
                this.createNewText = 'Create a New Meeting';
            }
            this.showSaveSnackbar = true;
            setTimeout(() => {
                this.showSaveSnackbar = false;
            }, 12000);
        }
        this.$emit(EventTypes.TASK_ADD_ANOTHER, this.family);
    }

    private handleCreateAnother() {
        if (this.isMeeting) {
            this.$emit(EventTypes.MEETING_ADD, this.family);
        } else {
            this.$emit(EventTypes.TASK_ADD_ANOTHER, this.family);
        }
        this.showSaveSnackbar = false;
    }

    private handleCreateNew() {
        if (this.isMeeting) {
            this.$emit(EventTypes.TASK_ADD_ANOTHER, this.family);
        } else {
            this.$emit(EventTypes.MEETING_ADD, this.family);
        }
        this.showSaveSnackbar = false;
    }

    private async completeTask(task: TaskUpdateDto) {
        task.completed_by_user_id = authStore.userInfoObject?.id; // who did? you did!
        if (this.isNewTaskModal) {
            this.taskSavedMessage = `${this.isMeeting ? 'Meeting Saved' : 'Task Saved'}`;
        } else {
            this.taskSavedMessage = `${this.isMeeting ? 'Meeting' : 'Task'} Completed.`;
        }
        await taskUtils.completeTask(task, this.isMeeting, this.isMeeting && this.exportToIcsFile);
        if (this.family) {
            // Save child birth date changes if modified (only in new task modal)
            if (this.isNewTaskModal && this.childDtos.length > 0) {
                for (let i = 0; i < this.childDtos.length; i++) {
                    if (this.childDtos[i].date_of_birth !== this.originalChildDtos[i].date_of_birth) {
                        await childrenRepo.update(this.family.id, this.childDtos[i]);
                    }
                }
            }
            await changeStatus.writePendingChanges(this.family.id);
        }
    }

    private async cancelTask() {
        if (!this.taskDto) {
            return;
        }
        if (this.isNewTaskModal) {
            this.showWarningDrawer = true;
        } else {
            this.$swal({
                text: `Are you sure you want to remove this ${this.taskLabel}?`,
                showConfirmButton: true,
                showCancelButton: true
            }).then(async (result: any) => {
                if (result.isConfirmed) {
                    loadingState.loadingIncrement(this.loadingKey);
                    this.taskSavedMessage = `${this.isMeeting ? 'Meeting' : 'Task'} Removed.`;
                    if (isTaskPastDue(this.taskDto!) && this.isMeeting) {
                        tasksStore.decrementPastDueToursWithin30DaysCount();
                    }
                    await tasksRepository.cancel(this.taskDto!);
                    loadingState.loadingDecrement(this.loadingKey);
                    this.closeModal(true);
                }
            });
        }
    }

    private handleWarningCancel() {
        this.showWarningDrawer = false;
    }

    private async handleWarningProceed() {
        if (!this.taskDto) {
            return;
        }

        try {
            loadingState.loadingIncrement(this.loadingKey);
            if (isTaskPastDue(this.taskDto!) && this.isMeeting) {
                tasksStore.decrementPastDueToursWithin30DaysCount();
            }
            await tasksRepository.cancel(this.taskDto!);

            loadingState.loadingDecrement(this.loadingKey);
            this.showWarningDrawer = false;
            this.closeModal(true);
            this.deleteSnackbarMessage = `${this.isMeeting ? 'Meeting' : 'Task'} Deleted.`;

            this.showDeleteSnackbar = true;

            setTimeout(() => {
                this.showDeleteSnackbar = false;
            }, 12000);
        } catch (error) {
            loadingState.loadingDecrement(this.loadingKey);
        }
    }

    private handleGoToFamily() {
        this.showDeleteSnackbar = false;
        this.showSaveSnackbar = false;
        this.navigateToFamilyHub();
    }

    private closeModal(taskSaved: boolean) {
        this.taskSaved = taskSaved;
        if (taskSaved) {
            this.$emit(EventTypes.UPDATED, this.task);
        }

        this.isChanged = false;
        this.isResultChanged = false;
        this.isOpen = false;

        this.$emit(EventTypes.CLOSE);
    }

    private async navigateToFamilyHub() {
        if (!this.family) {
            return;
        }

        if (this.newTabStatus) {
            if (this.canAddCrmTabs) {
                await layoutTabsStore.addTab({
                    routeName: 'family-hub',
                    routeParams: { id: this.family.id.toString() },
                    goTo: true,
                    tabTitle: this.family.primary_guardian.last_name
                });
            } else {
                const routeData = this.$router.resolve({
                    name: 'family-hub',
                    params: { id: this.family.id.toString() }
                });
                window.open(routeData.href, '_blank');
            }
        } else {
            await this.$router.push({
                name: 'family-hub',
                params: { id: this.family.id.toString() }
            });
        }
    }

    // Go to the family; confirm if changes have been made to the task
    private async goToFamily() {
        if (!this.family || !this.taskDto) {
            return;
        }

        if (taskUtils.hasTaskBeenModified(this.task!, this.taskDto)) {
            this.$swal({
                text: 'You will lose any unsaved changes. Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Discard Changes',
                cancelButtonText: 'Go Back'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await this.navigateToFamilyHub();
                }
            });
        } else {
            await this.navigateToFamilyHub();
        }
    }

}
